export default __webpack_public_path__ + "static/media/block8-3.522f1f97.png";